import { defineMessages } from "react-intl";

export enum AssistantSignUpType {
  segmenationSectionTitle = "AssistantSignUpType.segmenationSectionTitle",
  email = "AssistantSignUpType.email",
  password = "AssistantSignUpType.password",
  firstName = "AssistantSignUpType.firstName",
  lastName = "AssistantSignUpType.lastName",
  branches = "AssistantSignUpType.branches",
  regions = "AssistantSignUpType.regions",

  submit = "AssistantSignUpType.submit",

  warningTitle = "AssistantSignUpType.warningTitle",
  errorTitle = "AssistantSignUpType.errorTitle",
  infoTitle = "AssistantSignUpType.infoTitle",

  passwordMin = "AssistantSignUpType.passwordMin",
  passwordWithNumber = "AssistantSignUpType.passwordNumber",
  passwordWithSpecialCharacter = "AssistantSignUpType.passwordSpecialCharacter",
  passwordWithCapital = "AssistantSignUpType.passwordCapital",

  segmenationPopUpInfo = "AssistantSignUpType.segmenationPopUpInfo",
}

const en = {
  [AssistantSignUpType.segmenationSectionTitle]: "Assignments",
  [AssistantSignUpType.email]: "Email Address",
  [AssistantSignUpType.password]: "Password",
  [AssistantSignUpType.firstName]: "First Name",
  [AssistantSignUpType.lastName]: "Last Name",
  [AssistantSignUpType.branches]: "Branches",
  [AssistantSignUpType.regions]: "Regions",

  [AssistantSignUpType.submit]: "Next",

  [AssistantSignUpType.warningTitle]: "Warning",
  [AssistantSignUpType.errorTitle]: "Sign Up error:",
  [AssistantSignUpType.infoTitle]: "Hey",

  [AssistantSignUpType.passwordMin]: "Password must be at least 8 characters.",
  [AssistantSignUpType.passwordWithCapital]: "Password must be at least 1 capital letter.",
  [AssistantSignUpType.passwordWithNumber]: "Password must be at least 1 numeric value.",
  [AssistantSignUpType.passwordWithSpecialCharacter]: "Password must be at least 1 special character.",

  [AssistantSignUpType.segmenationPopUpInfo]:
    "Please select the Branches and/or Regions this Admin should have access to.",
};

export const descriptors = defineMessages({
  [AssistantSignUpType.segmenationPopUpInfo]: {
    id: AssistantSignUpType.segmenationPopUpInfo,
    defaultMessage: en[AssistantSignUpType.segmenationPopUpInfo],
    description: "-",
  },
  [AssistantSignUpType.segmenationSectionTitle]: {
    id: AssistantSignUpType.segmenationSectionTitle,
    defaultMessage: en[AssistantSignUpType.segmenationSectionTitle],
    description: "-",
  },
  [AssistantSignUpType.email]: {
    id: AssistantSignUpType.email,
    defaultMessage: en[AssistantSignUpType.email],
    description: "Email address",
  },
  [AssistantSignUpType.password]: {
    id: AssistantSignUpType.password,
    defaultMessage: en[AssistantSignUpType.password],
    description: "Password text",
  },
  [AssistantSignUpType.firstName]: {
    id: AssistantSignUpType.firstName,
    defaultMessage: en[AssistantSignUpType.firstName],
    description: "firstName text",
  },
  [AssistantSignUpType.lastName]: {
    id: AssistantSignUpType.lastName,
    defaultMessage: en[AssistantSignUpType.lastName],
    description: "lastName text",
  },
  [AssistantSignUpType.branches]: {
    id: AssistantSignUpType.firstName,
    defaultMessage: en[AssistantSignUpType.branches],
    description: "branches",
  },
  [AssistantSignUpType.regions]: {
    id: AssistantSignUpType.regions,
    defaultMessage: en[AssistantSignUpType.regions],
    description: "regions",
  },
  [AssistantSignUpType.submit]: {
    id: AssistantSignUpType.submit,
    defaultMessage: en[AssistantSignUpType.submit],
    description: "",
  },
  [AssistantSignUpType.warningTitle]: {
    id: AssistantSignUpType.warningTitle,
    defaultMessage: en[AssistantSignUpType.warningTitle],
    description: "Warning messages title",
  },
  [AssistantSignUpType.errorTitle]: {
    id: AssistantSignUpType.errorTitle,
    defaultMessage: en[AssistantSignUpType.errorTitle],
    description: "Error Messages title",
  },
  [AssistantSignUpType.infoTitle]: {
    id: AssistantSignUpType.infoTitle,
    defaultMessage: en[AssistantSignUpType.infoTitle],
    description: "Info messages title",
  },
  [AssistantSignUpType.passwordMin]: {
    id: AssistantSignUpType.passwordMin,
    defaultMessage: en[AssistantSignUpType.passwordMin],
    description: "passwordMin",
  },
  [AssistantSignUpType.passwordWithCapital]: {
    id: AssistantSignUpType.passwordWithCapital,
    defaultMessage: en[AssistantSignUpType.passwordWithCapital],
    description: "passwordWithCapital text",
  },
  [AssistantSignUpType.passwordWithNumber]: {
    id: AssistantSignUpType.passwordWithNumber,
    defaultMessage: en[AssistantSignUpType.passwordWithNumber],
    description: "passwordWithNumber",
  },
  [AssistantSignUpType.passwordWithSpecialCharacter]: {
    id: AssistantSignUpType.passwordWithSpecialCharacter,
    defaultMessage: en[AssistantSignUpType.passwordWithSpecialCharacter],
    description: "passwordWithSpecialCharacter",
  },
});
